export function initializeCategorySelection() {
    document.addEventListener('DOMContentLoaded', function () {
        // Select all category buttons and post items
        var buttons = document.querySelectorAll('.category-button');
        var posts = document.querySelectorAll('.post-item');
        // Add click event listeners to all buttons
        buttons.forEach(function (button) {
            button.addEventListener('click', function () {
                // Get the selected category from the clicked button
                var selectedCategory = button.getAttribute('data-category');
                if (!selectedCategory) {
                    // If no category is found, exit early
                    return;
                }
                // Add "active" class to the clicked button and remove it from others
                buttons.forEach(function (btn) { return btn.classList.remove('active'); });
                button.classList.add('active');
                // Filter posts based on the selected category
                posts.forEach(function (post) {
                    var postCategories = post.getAttribute('data-categories');
                    if (postCategories) {
                        var postCategoryList = postCategories.split(' ');
                        // Use indexOf for compatibility with ES5
                        if (selectedCategory === 'all' || postCategoryList.indexOf(selectedCategory) !== -1) {
                            post.style.display = 'block'; // Show the post
                        }
                        else {
                            post.style.display = 'none'; // Hide the post
                        }
                    }
                });
            });
        });
    });
}
